import { render, staticRenderFns } from "./DynamicCode.vue?vue&type=template&id=5a8b240e&scoped=true&"
import script from "./DynamicCode.vue?vue&type=script&lang=js&"
export * from "./DynamicCode.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCode.vue?vue&type=style&index=0&id=5a8b240e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b240e",
  null
  
)

export default component.exports